"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bgImageHelperStyle = void 0;

var _grid = require("../grid");

var bgImageHelperStyle = function bgImageHelperStyle(bgImage) {
  return (0, _grid.map)(bgImage, function (i) {
    return "background-image: url(".concat(i, "); background-repeat: no-repeat; background-position: 50% 50%; background-size: cover;");
  });
};

exports.bgImageHelperStyle = bgImageHelperStyle;